<footer id="footer">
    <div class="footer-text justify-start gap-3 flex-nowrap flex items-baseline">
        <a [routerLink]="['/about']" id="about" jhiTranslate="aboutUs" class="shrink-0"></a>
        <a [href]="FEEDBACK_URL" id="feedback" jhiTranslate="feedback" class="shrink-0" target="_blank"></a>
        <a [href]="RELEASE_URL" id="releases" jhiTranslate="releases" class="shrink-0" target="_blank"></a>
        <a [routerLink]="['/privacy']" id="privacy" jhiTranslate="artemisApp.legal.privacy" class="shrink-0"></a>
        <a [routerLink]="['/imprint']" id="imprint" jhiTranslate="artemisApp.legal.imprint.title" class="shrink-0"></a>
        @if (!isProduction() || isTestServer()) {
            <span class="shrink-0 footer-git footer-git-responsive">
                <small>
                    {{ gitBranch() }} • {{ 'artemisApp.git.commit' | artemisTranslate }}: {{ gitCommitId() }} • {{ 'artemisApp.git.timestamp' | artemisTranslate }}:
                    {{ gitTimestamp() | artemisDate: 'short' }} • {{ gitCommitUser() }}
                </small>
            </span>
        }
    </div>
</footer>
